<template>
    <div
        class="box-container"
        :style="{
            borderColor: color.primary,
            color: color.primary,
        }"
    >
        <div
            class="top-bar"
            :style="{
                borderColor: color.primary,
            }"
        ></div>
        <div class="top-bar-text">...</div>
        <div class="content">{{ value }}</div>
    </div>
</template>
<script>
export default {
    name: 'GamificationBox',

    props: {
        value: String,
        color: {
            type: Object,
            required: true,
        },
    },
};
</script>
<style scoped>
    .box-container {
        max-width: 150px;
        padding: 10px;
        border: 2px solid;
        border-radius: 5px;
        position: relative;
    }

    .top-bar {
        height: 20px;
        border-top: 2px solid;
        border-bottom: 2px solid;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        position: absolute;
        top: -2px;
        left: 0;
        right: 0;
    }

    .content {
        padding-top: 20px;
        font-size: 16px;
        font-weight: bold;
    }

    .top-bar-text {
        font-size: 42px;
        position: absolute;
        top: -34px;
        left: 12px;
        right: 0;
    }
</style>
    